import React from 'react';
import {Spin, Table, Typography} from 'antd';
import dayjs from 'dayjs';

import SharesExchangeDrawer from './SharesExchangeDrawer';
import EngageCurrency from '../billings/EngageCurrency';
import {dateFormat, timeFormat} from '../../lib/time';

import './SharesHistoryTable.less';
import {black, successGreen} from '../../assets/colors';
import {SharesHistoryTableProps} from '../../types/purchaseTypes';

const columns = [
    {
        title: <Typography.Text strong>Date</Typography.Text>,
        dataIndex: 'purchased_at',
        key: 'purchased_at_date',
        render: (purchased_at: string) => (
            <span className="purchased-date-line-item long-text-wrap">
                {dayjs(purchased_at).tz().format(dateFormat)}
            </span>
        ),
    },
    {
        title: <Typography.Text strong>Time</Typography.Text>,
        dataIndex: 'purchased_at',
        key: 'purchased_at_time',
        render: (purchased_at: string) => (
            <span className="purchased-time-line-item long-text-wrap">
                {dayjs(purchased_at).tz().format(timeFormat)}
            </span>
        ),
    },
    {
        title: <Typography.Text strong>Account</Typography.Text>,
        dataIndex: 'account_number',
        key: 'account_receiving',
        render: (account_number: string) => (
            <span className="membership-number-line-item long-text-wrap">
                {account_number}
            </span>
        ),
    },
    {
        title: <Typography.Text strong>No. of Shares</Typography.Text>,
        dataIndex: 'num_of_items',
        key: 'num_of_items',
        render: (number: number) => (
            <span
                style={{color: number > 0 ? black : successGreen}}
                className="number-of-shares-line-item long-text-wrap"
            >
                {number}
            </span>
        ),
    },
    {
        title: <Typography.Text strong>Value of Shares</Typography.Text>,
        dataIndex: 'amount',
        key: 'amount',
        render: (amount: number) => (
            <span className="amount-line-item long-text-wrap">
                <EngageCurrency
                    amount={parseFloat(amount.toString())}
                    style={{color: amount > 0 ? black : successGreen}}
                />
            </span>
        ),
    },
    {
        title: <Typography.Text strong>Share Balance</Typography.Text>,
        dataIndex: 'balance',
        key: 'share_balance',
        render: (balance: number) => (
            <span className="share-balance-line-item long-text-wrap">
                {balance}
            </span>
        ),
    },
];

const SharesHistoryTable = ({
                                loading,
                                totalRows,
                                purchases,
                                sharableType,
                                isOwner
                            }: SharesHistoryTableProps) => {
    const [page, setPage] = React.useState(1);
    const [perPage, setPerPage] = React.useState(10);

    const onChange = (page: number, perPage: number) => {
        setPage(page);
        setPerPage(perPage);
    };

    const paginationAttr = {
        current: page,
        pageSize: perPage,
        total: totalRows,
        onChange,
        showSizeChanger: true,
        simple: window.innerWidth <= 767,
        showTotal: (total: number, range: [number, number]) => `${range[0]}-${range[1]} of ${total} items`,
        onShowSizeChange: onChange,
    };

    return (
        <Spin spinning={loading}>
            <Table
                rowKey="id"
                dataSource={purchases}
                columns={columns}
                bordered={false}
                className="shares-history-table responsive-table"
                pagination={paginationAttr}
                title={() => (
                    <div className="shares-history-table-title">
                        <div>
                            <Typography.Text>Share Transaction History</Typography.Text>
                        </div>
                        <div className="shares-history-table-btn-container">
                            <SharesExchangeDrawer
                                typeOfTransaction="sell"
                                sharableType={sharableType}
                                isOwner={isOwner}
                            />
                            <SharesExchangeDrawer
                                typeOfTransaction="buy"
                                sharableType={sharableType}
                                isOwner={isOwner}
                            />
                        </div>
                    </div>
                )}
            />
        </Spin>
    );
};

export default SharesHistoryTable;
